import {Card, Stack, styled, Typography} from '@mui/material';

const StyledCard = styled(Card)`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	height: 100%;
	box-shadow: none;
	border: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledDataContent = styled(Stack)`
	gap: 8px;
	padding: 8px 16px;
	padding-block: 8px;
	flex: 1;
	width: 100%;
`;

const StyledHeaderContainer = styled(Stack)`
	width: 100%;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	border-bottom: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledTitle = styled(Typography)`
	font-size: 18px;
`;

const StyledButtonsContainer = styled(Stack)`
	width: 100%;
	flex-direction: row;
	align-items: center;
	padding: 12px 16px;
	gap: 12px;
`;

export {StyledButtonsContainer, StyledCard, StyledDataContent, StyledHeaderContainer, StyledTitle};
